<template>
    <div>
        <sparator v-show="showSparatorButton"></sparator>
        <div class="relative overflow-hidden">
            <picture class="z-0 w-full">
                <source
                    media="(max-width: 768px)"
                    srcset="storage/pages/contribute/bg-landing-page-mobile.png"
                />
                <img
                    src="storage/pages/contribute/bg-landing-page.png"
                    alt=""
                    class="w-full"
                />
            </picture>
            <div class="absolute top-0 left-0 z-10 flex w-full h-full ">
                <div class="w-full mx-150 md:mx-50 pt-200 pl-200 md:pl-0">
                    <div
                        anime-title
                        class="font-semibold text-black text-40 md:text-center"
                    >
                        How To Contribute
                        <span class="text-5xl text-green-500">.</span>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="mx-150 md:mx-50 py-150">
                <div class="text-black text-25 mb-100">
                    We believe in collaboration.<br />Thats why we are very open
                    for anyone who are interested to be part of this cause.
                </div>

                <div>
                    <div
                        class="flex items-center justify-center bg-green-500 rounded-full mb-15 w-100 h-100 "
                    >
                        <icon name="email" class="w-5/12 h-auto text-white" />
                    </div>
                    <div class="text-60 md:text-35">
                        Email us to contribute@tanambenih.org
                    </div>
                </div>
            </div>
        </div>
        <div class="flex items-center justify-center h-screen">
            <youtube
                video-id="XyajwVAuYHE"
                :player-vars="{ controls: 0, rel: 0 }"
                ref="ytcontribute"
                class="w-full h-full"
            ></youtube>
        </div>
        <div class="">
            <div class="mx-150 md:mx-50 py-150 ">
                <div :class="this.$css.title">
                    Donation Model<span :class="this.$css.titleGreen">.</span>
                </div>
                <div class="text-25 mb-50">
                    Donation are available via free donation, topic sponsorship,
                    video sponsorship or other forms of partnership. BUT. We
                    will never compromise on content purpose or commercialize
                    content to deviate from raising kids right.
                </div>
                <div class="flex items-stretch md:flex-col -mx-15 md:-mx-0">
                    <div
                        class="flex-1 border-green-500 border-1 mx-15 md:mb-15 p-50"
                    >
                        <div class="font-semibold leading-none text-100">
                            01<span :class="this.$css.titleGreen">.</span>
                        </div>
                        <div class="font-semibold text-40 ">
                            Free Donations<span :class="this.$css.titleGreen"
                                >.</span
                            >
                        </div>
                        <div class="text-20">
                            Contribute
                            <!--as low as Rp 50,000 -->to support us in
                            producing good quality video regularly
                        </div>
                    </div>
                    <div
                        class="flex-1 border-green-500 border-1 mx-15 md:mb-15 p-50"
                    >
                        <div class="font-semibold leading-none text-100">
                            02<span :class="this.$css.titleGreen">.</span>
                        </div>
                        <div class="font-semibold text-40 ">
                            Topic Donations<span :class="this.$css.titleGreen"
                                >.</span
                            >
                        </div>
                    </div>
                    <div
                        class="flex-1 border-green-500 border-1 mx-15 md:mb-15 p-50"
                    >
                        <div class="font-semibold leading-none text-100">
                            03<span :class="this.$css.titleGreen">.</span>
                        </div>
                        <div class="font-semibold text-40 ">
                            Video Donations<span :class="this.$css.titleGreen"
                                >.</span
                            >
                        </div>
                    </div>
                </div>
                <div class="text-center mt-50">
                    <inertia-link
                        @click="toggleShowButton"
                        :href="route('donate.index')"
                        :class="this.$css.button"
                    >
                        DONATE NOW</inertia-link
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Icon from "@/Shared/Icon";
import VueYoutube from "vue-youtube";
import Sparator from "../../../components/Sparator.vue";

export default {
    data() {
        return {
            showSparatorButton: false
        };
    },
    metaInfo() {
        return {
            title: this.head.title
        };
    },
    layout: Layout,
    components: {
        Icon,
        VueYoutube,
        Sparator
    },

    props: {
        head: Object
    },
    methods: {
        toggleShowButton() {
            this.showSparatorButton = true;
        }
    }
};
</script>
